import React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useRef } from "react";

import {
  Chip,
  Grid,
  Box,
  IconButton,
  OutlinedInput,
  InputAdornment,
  Popper,
  Paper,
  ClickAwayListener,
  Avatar,
} from "@material-ui/core";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import DescriptionIcon from "@material-ui/icons/Description";
import PhoneIcon from "@material-ui/icons/Phone";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import CurrencyIcon from "@material-ui/icons/AttachMoney";
import BooleanIcon from "@material-ui/icons/CheckBox";
import DateIcon from "@material-ui/icons/Today";
import DropDownIcon from "@material-ui/icons/ArrowDropDown";
import CheckboxGroupIcon from "@material-ui/icons/LibraryAddCheck";
import FileIcon from "@material-ui/icons/Attachment";
import BarcodeIcon from "@material-ui/icons/CropFree";
import SubsheetIcon from "@material-ui/icons/GridOn";
import FormulaIcon from "@material-ui/icons/Code";
import UserIcon from "@material-ui/icons/Person";
import LinkIcon from "@material-ui/icons/Link";
import { AiOutlinePercentage } from "react-icons/ai";
import COLORS from "scss/colors.module.scss";

const columnTypes = [
  {
    name: "Basic",
    value: "basic",
    subMenuItems: [
      {
        name: "Text/Email",
        value: "text/email",
        icn: "text.png",
        subMenuItems: [
          {
            name: "Text",
            value: "text",
            icn: "text.png",
            column_type_id: 1,
            Icon: TextFieldsIcon,
          },
          {
            name: "Email",
            value: "email",
            icn: "text.png",
            Icon: AlternateEmailIcon,
            column_type_id: 14,
          },
          {
            name: "Url",
            value: "url",
            icn: "text.png",
            Icon: LinkIcon,
            column_type_id: 24,
          },
          {
            name: "Multi-line Text/Textarea",
            value: "textarea",
            icn: "text.png",
            Icon: DescriptionIcon,
            column_type_id: 8,
          },
          {
            name: "Phone",
            value: "phone",
            icn: "text.png",
            Icon: PhoneIcon,
            column_type_id: 20,
          },
        ],
      },
      {
        name: "Number ",
        value: "number",
        icn: "num.png",
        subMenuItems: [
          {
            name: "Number",
            value: "number",
            icn: "num.png",
            Icon: FormatListNumberedIcon,
            column_type_id: 5,
          },
          {
            name: "Currency",
            value: "currency",
            icn: "currency.png",
            Icon: CurrencyIcon,
            column_type_id: 17,
          },
          {
            name: "Percentage",
            value: "percentage",
            icn: "num.png",
            Icon: AiOutlinePercentage,
            column_type_id: 22,
          },
          {
            name: "Boolean",
            value: "boolean",
            icn: "num.png",
            Icon: BooleanIcon,
            column_type_id: 12,
          },

          {
            name: "Formula",
            value: "expressionformula",
            icn: "dropdown.png",
            Icon: FormulaIcon,
            column_type_id: 19,
          },
        ],
      },
      {
        name: "Date ",
        value: "date",
        icn: "date_icon.png",
        subMenuItems: [
          {
            name: "Date",
            value: "date",
            icn: "date_icon.png",
            Icon: DateIcon,
            column_type_id: 4,
          },
          {
            name: "DateTime",
            value: "datetime",
            icn: "date_icon.png",
            Icon: DateIcon,
            column_type_id: 16,
          },
        ],
      },
      {
        name: "Dropdown/Options",
        value: "dropdown/options",
        icn: "dropdown.png",
        subMenuItems: [
          {
            name: "Drop down",
            value: "dropdown",
            icn: "dropdown.png",
            Icon: DropDownIcon,
            column_type_id: 3,
          },
          {
            name: "Checklist/Checkbox Group",
            value: "checkboxgroup",
            icn: "multi_checkbox.png",
            Icon: CheckboxGroupIcon,
            column_type_id: 13,
          },
          {
            name: "Multi-Select",
            value: "multiselect",
            icn: "dropdown.png",
            Icon: DropDownIcon,
            column_type_id: 11,
          },
          { type: "hr" },
        ],
      },
      {
        name: "Code Snippet",
        value: "formula",
        icn: "dropdown.png",
        Icon: FormulaIcon,
        column_type_id: 7,
      },
      {
        name: "File / Image ",
        value: "file",
        icn: "attachment.png",
        Icon: FileIcon,
        column_type_id: 9,
      },
      {
        name: "Barcode",
        value: "barcode",
        icn: "barcode.png",
        column_type_id: 18,
        Icon: BarcodeIcon,
      },
    ],
  },
  {
    name: "Lookup",
    value: "lookup",
    icn: "dropdown.png",
    Icon: DropDownIcon,
    column_type_id: 10,
  },
  {
    name: "Subsheet",
    value: "sheet",
    icn: "dropdown.png",
    column_type_id: 6,
    Icon: SubsheetIcon,
  },
  {
    name: "User",
    value: "user",
    icn: "dropdown.png",
    column_type_id: "10-1",
    Icon: UserIcon,
  },
];

const getColumnsArrayPlain = (items, acc = [], tag = "") =>
  items.reduce((acc, colType) => {
    if (colType.subMenuItems && acc.length !== 0) {
      acc.push({ type: "hr" });
    }
    colType.subMenuItems
      ? getColumnsArrayPlain(
          colType.subMenuItems,
          acc,
          tag + "," + colType.name
        )
      : acc.push({ ...colType, tag: tag });
    if (colType.subMenuItems && acc.length === 0) {
      acc.push({ type: "hr" });
    }
    return acc;
  }, acc);
export const columnTypesArrayPlain = getColumnsArrayPlain(columnTypes);

function getColumnsInGroups(columns) {
  const data = [];
  let subdata = [];

  columns.forEach((col) => {
    if (col.type === "hr") {
      data.push(subdata);
      subdata = [];
      return;
    }
    subdata.push(col);
  });

  data.push(subdata);

  return data;
}

function ColumnTypesListPopup({
  isSubsheet,
  onClose,
  onChange,
  value,
  handleSubmit,
}) {
  const [selectedTag, setSelectedTag] = useState("");
  const [searchText, setSearchText] = useState(value);
  const inputRef = useRef();
  const [open, setOpen] = useState(false);
  const isModified = value !== searchText;

  React.useEffect(() => {
    setSearchText(value);
  }, [value]);

  const columnTypesToShow = columnTypesArrayPlain.filter((i) => {
    if (i.type === "hr") {
      return true;
    }
    return (
      (!isSubsheet || i.column_type_id !== 6) &&
      (!selectedTag ||
        i.tag.toLowerCase().includes(selectedTag.toLowerCase())) &&
      (!searchText ||
        !isModified ||
        i.name.toLowerCase().startsWith(searchText.toLowerCase()))
    );
  });

  const handleChange = (e) => {
    setSelectedTag("");
    console.log(e);
    onChange(e);
    setOpen(false);
  };

  const handleMenuClose = () => {
    if (value !== searchText) {
      const newValue = columnTypesArrayPlain.find(
        (col) => col.name?.toLowerCase() === searchText.toLowerCase()
      );
      if (!newValue) {
        setSearchText(value);
      } else {
        onChange(newValue);
      }
    }
    setOpen(false);
  };

  const header = (
    <Grid container direction="column" alignItems="center" spacing={1}>
      <Box width="277px">
        <Grid item container spacing={1} justify="center">
          {["Basic", "Text/Email", "Number", "Date", "Dropdown/Options"].map(
            (val) => (
              <Grid item>
                <Chip
                  label={val}
                  clickable
                  color={selectedTag === val ? "primary" : ""}
                  onClick={() => setSelectedTag(val === selectedTag ? "" : val)}
                />
              </Grid>
            )
          )}
        </Grid>
      </Box>
    </Grid>
  );

  let chipCounter = 0;
  return (
    <ClickAwayListener onClickAway={handleMenuClose}>
      <div>
        <Grid item>
          <TextFieldLarge
            fullWidth
            variant="outlined"
            ref={inputRef}
            onFocus={(e) => {
              !open && setOpen(true);
            }}
            onKeyDown={(e) => {
              if (
                (e.key === "Enter" || e.key === "Tab") &&
                e.target.value !== value
              ) {
                const columnType = columnTypesToShow.find(
                  (col) => col.type !== "hr"
                );
                if (columnType) {
                  setSearchText(columnType.name);
                  onChange(columnType);
                  setOpen(false);
                  return;
                }
                handleMenuClose();
              } else if (e.key === "Enter") {
                if (open) {
                  setOpen(false);
                } else {
                  handleSubmit(e);
                }
              }
            }}
            onClick={(e) => e.stopPropagation()}
            defaultValue={value}
            value={searchText}
            onChange={(e) => {
              !open && setOpen(true);
              setSearchText(e.target.value);
            }}
            placeholder="Choose field type"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={(e) => {
                    !open && setOpen(true);
                  }}
                  edge="end"
                >
                  <ArrowDropDownIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Grid>
        <MenuElement
          open={open}
          anchorEl={inputRef.current}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          onMenuItemClick={handleChange}
        >
          <Grid container spacing={1}>
            {getColumnsInGroups(columnTypesToShow).map((columnGroup, index) => {
              if (columnGroup.length === 0) {
                return null;
              }
              return (
                <ColumnGroupGrid
                  item
                  container
                  spacing={1}
                  borderTop={index !== 0}
                >
                  {columnGroup.map((menuItem, chipIndex) => {
                    const Icon = menuItem.Icon;
                    chipCounter++;
                    return (
                      <Grid item>
                        <StyledChip
                          highlighted={
                            chipCounter === 1 &&
                            !!searchText &&
                            value !== searchText
                          }
                          avatar={
                            Icon ? (
                              menuItem.column_type_id == 22 ? (
                                <Icon style={{ height: "15px", width: "15px", marginLeft:"8px" }} />
                              ) : (
                                <Icon />
                              )
                            ) : (
                              <Avatar>{menuItem.name[0]}</Avatar>
                            )
                          }
                          label={menuItem.name}
                          clickable
                          onClick={() => handleChange(menuItem)}
                        />
                      </Grid>
                    );
                  })}
                </ColumnGroupGrid>
              );
            })}
          </Grid>
        </MenuElement>
      </div>
    </ClickAwayListener>
  );
}

function MenuElement({ children, ...otherProps }) {
  return (
    <StyledPopper {...otherProps}>
      <StyledPaper>{children}</StyledPaper>
    </StyledPopper>
  );
}

const StyledPopper = styled(Popper)`
  && {
    z-index: 111111;
    width: 330px;
  }
`;

const StyledPaper = styled(Paper)`
  && {
    padding: 10px;
  }
`;

const TextFieldLarge = styled(OutlinedInput)`
  && {
    input {
      font-size: 14px !important;
      height: 26px;
    }
  }
`;

const StyledChip = styled(Chip)`
  && {
    font-size: 13px;
    .MuiChip-label {
      padding-left: 10px;
    }
    .MuiChip-label {
      color: #212121;
    }
    .MuiSvgIcon-root.MuiChip-avatar {
      width: 15px;
      height: 15px;
      margin-left: 8px;
    }
    border: ${(props) =>
      props.highlighted ? "2px solid " + COLORS.THEME_COLOR : ""};
  }
`;

const ColumnGroupGrid = styled(Grid)`
  && {
    margin-top: 5px;
    border-top: ${(props) =>
      props.borderTop ? "1px solid rgba(221, 221, 221, 0.5)" : ""};
  }
`;

export default ColumnTypesListPopup;
